import { useState, useRef, useEffect, useCallback } from "react"
import styles from "./styles.module.scss"
import cn from "clsx"
import type { FC, HTMLAttributes } from "react"
import { Hyper } from "components"


interface ContainerProps
extends HTMLAttributes<HTMLUListElement> {}

const PARTIAL_ITEMS_COUNT = 3
const INITIAL_HEIGHTS = {
  partial: 0,
  full: 0,
}

export const Container: FC<ContainerProps> = ({ className, ...rest }) => {
  const [ isOpen, setOpenState ] = useState(false)
  const [ heights, setHeights ] = useState(INITIAL_HEIGHTS)
  const timelineRef = useRef<HTMLUListElement>(null)
  const resizeHandler = useCallback(() => {
    const full = timelineRef.current.clientHeight
    const partial = Array.from(timelineRef.current.children)
      .slice(-PARTIAL_ITEMS_COUNT)
      .reduce((acc, item) => acc + item.clientHeight, 0)
    return setHeights({ full, partial })
  }, [setHeights])

  useEffect(() => {
    setTimeout(resizeHandler, 500)
    window.addEventListener('resize', resizeHandler, { passive: true })
    return () => window.removeEventListener('resize', resizeHandler)
  }, [resizeHandler])

  return (
    <>
      <div className={styles.wrapper} 
        style={{ height: isOpen ? heights.full : heights.partial }}>
        <ul className={cn(styles.container, className)} {...rest} ref={timelineRef} />
      </div>
      <div className={cn(styles.controls, {[styles.hidden]: isOpen })}>
        <Hyper.Button className={styles.link}
          type={isOpen ? 'ghost' : 'bordered'}
          onClick={setOpenState.bind(0, !isOpen)}>
          {isOpen ? 'View less ▵' : 'View all ▿'}
        </Hyper.Button>
      </div>
    </>
  )
}
